import { createModel } from 'xstate/lib/model';
import { passthroughEvent } from '@sweetgreen/garnish';

export enum OverlayToggleState {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}

export type OverlayEvent = {
  readonly overlayId: string;
  readonly toggleState: OverlayToggleState;
};

export type OverlayHook = {
  readonly isOpen: boolean;
  readonly open: () => void;
  readonly close: () => void;
};

export const overlayModel = createModel(
  {
    overlayId: '' as OverlayEvent['overlayId'],
  },
  {
    events: {
      OVERLAY: passthroughEvent as (event: OverlayEvent) => OverlayEvent,
    },
  },
);

export const overlayMachine = overlayModel.createMachine({
  predictableActionArguments: true, // https://xstate.js.org/docs/guides/actions.html
  id: 'sgOverlayMachine',
  context: overlayModel.initialContext,
  initial: 'ready',
  states: {
    ready: {
      on: {
        OVERLAY: {
          target: 'ready',
          actions: overlayModel.assign({
            overlayId(context, event) {
              const { toggleState, overlayId } = event;

              if (toggleState === 'OPEN') return overlayId;

              if (toggleState === 'CLOSE') {
                const shouldRemoveOverlay = overlayId === context.overlayId;

                if (shouldRemoveOverlay) return '';
              }

              return context.overlayId;
            },
          }),
        },
      },
    },
  },
});
